/*
 * Completed state of the to-dos behind notifications ("Neue Aufgabe vom System"): a to-do completed elsewhere (e.g. by the
 * QM-Cockpit backend when a case is decided / expired / discarded) shows "erledigt" instead of "Erledigen". Requests of
 * one tick are merged into one find; results are cached for a minute. Errors resolve to "not completed" (old behaviour).
 */
import {Types} from 'mongoose';
import {ToDoManagerApi} from '@/classes/api/to-do-manager.api.class';

const MAX_AGE_MS = 60 * 1000;
const cache = new Map<string, { done: boolean; at: number }>();
let queue = new Map<string, Array<(done: boolean) => void>>();
let timer = 0;

async function flush() {
    timer = 0;
    const current = queue;
    queue = new Map();
    const ids = Array.from(current.keys());
    let done = new Set<string>();
    try {
        const resp = await ToDoManagerApi.items.find({skipPagination: true, filter: {_id: ids as unknown as Types.ObjectId[]}, fields: ['completed']});
        done = new Set((resp?.items || []).filter((item) => !!item.completed).map((item) => String(item._id)));
    } catch (e) {
        done = new Set();
    }
    for (const id of ids) {
        cache.set(id, {done: done.has(id), at: Date.now()});
        (current.get(id) || []).forEach((resolve) => resolve(done.has(id)));
    }
}

/** true if the to-do is completed (batched, cached) */
export function isToDoCompleted(id: string): Promise<boolean> {
    if (!id) {
        return Promise.resolve(false);
    }
    const entry = cache.get(id);
    if (entry && Date.now() - entry.at < MAX_AGE_MS) {
        return Promise.resolve(entry.done);
    }
    return new Promise((resolve) => {
        queue.set(id, [...(queue.get(id) || []), resolve]);
        if (!timer) {
            timer = window.setTimeout(flush, 0);
        }
    });
}

/** After completing in the app: remember immediately */
export function markToDoCompleted(id: string) {
    if (id) {
        cache.set(id, {done: true, at: Date.now()});
    }
}
